/*
 * @Author: Teemo Ding
 * @Date: 2021-08-31 10:48:12
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 13:07:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleEdit/FlashSaleGroups/index.tsx
 */
import { Button, Label } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { DiscountType } from '@/src/types/common/discount';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import { useI18n } from 'src/hooks/useRouterChange';
import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import FlashSaleDiscount from '../../Components/FlashSaleDiscount';
import { last2Precision, last4Precision } from 'src/tools/regExp';

import css from '../css.module.less';

const FlashSaleGroups = ({ currency, form, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const radioList = (currency) => [
    {
      value: DiscountType.PercentageOff,
      label: getI18n('general.percentageOff'),
      suffix: '%',
      inputKey: 'percentageOff',
      //min: 0,
      max: 99.9999,
      mode: EnumMode.moneyOff,
    },
    {
      value: DiscountType.FixedReductionAmount,
      label: getI18n('salesChannelDirectDiscount.type.fixedReductionAmount'),
      suffix: currency || '',
      inputKey: 'reductionAmount',
      //min: 0,
      // max: 99.99,
      mode: EnumMode.moneyDeduction,
    },
  ];
  const handleAddFlashSaleGroup = (add) => {
    add({
      salesChannelProductList: [],
      flashSaleDiscount: {
        discountType: DiscountType.PercentageOff,
        percentageOff: null,
        reductionAmount: '',
        currencyCode: currency || '',
      },
    });
  };

  const disabledProducts = (getFieldValue, index) => {
    const flashSaleGroupsAll = getFieldValue('flashSaleGroups');
    const flashSaleGroupsOther = flashSaleGroupsAll.filter(
      (o, ind) => ind !== index,
    );
    const disabledProductsList = [].concat(
      ...flashSaleGroupsOther.map((item) => item.salesChannelProductList || {}),
    );
    return disabledProductsList;
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.tableContainer}
        title={getI18n('salesChannelFlashSale.groups.flashSaleGroups')}>
        <Form.List name='flashSaleGroups'>
          {(fields, { add, move, remove }, { errors }) => (
            <Fragment>
              {fields.map((item, index) => {
                return (
                  <div key={index} className={css.groupItem}>
                    <div className={css.flashSaleGroupTitle}>
                      {getI18n('salesChannelFlashSale.groups.flashSaleGroup')}
                      {index + 1}{' '}
                      {fields.length > 1 && (
                        <Button
                          type='danger'
                          ghost
                          disabled={disableEdit}
                          onClick={() => remove(index)}>
                          {getI18n('general.remove')}
                        </Button>
                      )}
                    </div>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, curValues) =>
                        prevValues.flashSaleGroups !== curValues.flashSaleGroups
                      }>
                      {({ getFieldValue }) => (
                        <Form.Item
                          name={[fields[index].name, 'salesChannelProductList']}
                          rules={[
                            {
                              validator: async (_, value) => {
                                if (!value.length) {
                                  return Promise.reject(
                                    getI18n(
                                      'general.advancedFilters.commonRadioMulSelect.selectItem',
                                    ),
                                  );
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            },
                          ]}>
                          <ProductTable
                            disableEdit={disableEdit}
                            disabledProducts={disabledProducts(
                              getFieldValue,
                              index,
                            )}
                            currency={currency}
                            withMultiCurrency={true}
                          />
                        </Form.Item>
                      )}
                    </Form.Item>

                    <Form.Item
                      className={css.flashSaleDiscount}
                      name={[fields[index].name, 'flashSaleDiscount']}
                      label={
                        <Label
                          title={getI18n(
                            'salesChannelFlashSale.groups.flashSaleDiscount',
                          )}
                        />
                      }
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          validator: async (_, value) => {
                            if (
                              value.discountType ===
                                DiscountType.PercentageOff &&
                              !value.percentageOff
                            ) {
                              return Promise.reject(
                                replaceI18nVariables(
                                  getI18n(`general.fieldisrequired`),
                                  getI18n('general.percentageOff'),
                                ),
                              );
                            } else if (
                              value.discountType ===
                                DiscountType.FixedReductionAmount &&
                              !value.reductionAmount
                            ) {
                              return Promise.reject(
                                replaceI18nVariables(
                                  getI18n(`general.fieldisrequired`),
                                  getI18n(
                                    'salesChannelDirectDiscount.type.fixedReductionAmount',
                                  ),
                                ),
                              );
                            } else if (
                              value.discountType ===
                                DiscountType.PercentageOff &&
                              !last4Precision.test(value.percentageOff)
                            ) {
                              return Promise.reject(
                                new Error(
                                  getI18n(
                                    'salesChannelDirectDiscount.discountValue.fourDecimal',
                                  ),
                                ),
                              );
                            } else if (
                              value.discountType ===
                                DiscountType.FixedReductionAmount &&
                              !last2Precision.test(value.reductionAmount)
                            ) {
                              return Promise.reject(
                                new Error(
                                  getI18n(
                                    'salesChannelDirectDiscount.discountValue.twoDecimal',
                                  ),
                                ),
                              );
                            } else {
                              return Promise.resolve();
                            }
                          },
                        },
                      ]}>
                      <FlashSaleDiscount
                        radioKey='discountType'
                        radioList={radioList(currency)}
                        disableEdit={disableEdit}
                      />
                    </Form.Item>
                  </div>
                );
              })}
              {disableEdit ? null : (
                <div className={css.addFlashSaleGroup}>
                  <span
                    className={css.addFlashSaleGroup}
                    onClick={() => handleAddFlashSaleGroup(add)}>
                    +{getI18n('salesChannelFlashSale.groups.addFlashSaleGroup')}
                  </span>
                </div>
              )}
            </Fragment>
          )}
        </Form.List>
      </SectionWrapper>
    </div>
  );
};

export default FlashSaleGroups;
